export default "05c920d30fe45461.svg"